function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction column;\n  min-height: 100vh;\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 50%;\n  margin: 2rem auto 0 auto;\n\n  @media screen and (max-width: 480px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React, { Suspense } from "react";
import styled from "styled-components";
import { Router as ReactRouter, Route, Switch } from "react-router-dom";
import { WrContextProvider, withContext } from "../wr-context";
import Progress from "../progress";
import LoginForm from "../login-form";
import SimplePassword from "../simple-pass";
import propTypes from "prop-types";
import AuthResolver from "../auth-resolver";
import { PreProdBanner, PreProdButton } from "../PreProd";
var Root = styled.div(_templateObject());
var LoginContainer = styled.div(_templateObject1());
var AuthHandler = withContext(function(param) {
    var children = param.children, requireAuth = param.requireAuth, requireSsoAuth = param.requireSsoAuth, requirePass = param.requirePass, isLoggedIn = param.isLoggedIn;
    return (requireAuth || requireSsoAuth) && !isLoggedIn ? /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(Progress, null)
    }, /*#__PURE__*/ React.createElement(Switch, null, /*#__PURE__*/ React.createElement(LoginContainer, null, /*#__PURE__*/ React.createElement(Route, {
        path: "/",
        component: requireSsoAuth ? AuthResolver : LoginForm
    })))) : requirePass && !localStorage.getItem("isLogged") ? /*#__PURE__*/ React.createElement(SimplePassword, null) : children;
}, {
    mapProps: function(context) {
        return {
            isLoginResolving: context.state.isLoginResolving,
            isLoggedIn: context.state.isLoggedIn,
            requireAuth: context.constants.requireAuth,
            history: context.history,
            requireSsoAuth: context.constants.requireSsoAuth,
            requirePass: context.constants.requirePass,
            appHost: context.constants.appHost
        };
    }
});
var RouterProvider = withContext(function(param) {
    var context = param.context, children = param.children;
    return /*#__PURE__*/ React.createElement(ReactRouter, {
        history: context.history
    }, children);
});
var WrRoot = function(param) {
    var children = param.children;
    return /*#__PURE__*/ React.createElement(WrContextProvider, null, /*#__PURE__*/ React.createElement(RouterProvider, null, /*#__PURE__*/ React.createElement(Root, null, /*#__PURE__*/ React.createElement(AuthHandler, null, /*#__PURE__*/ React.createElement(React.Fragment, null, children, /*#__PURE__*/ React.createElement(PreProdBanner, null), /*#__PURE__*/ React.createElement(PreProdButton, null))))));
};
WrRoot.propTypes = {
    children: propTypes.node.isRequired
};
export default WrRoot;
